import { render, staticRenderFns } from "./CarouselElement.vue?vue&type=template&id=ee7e3dd8"
import script from "./CarouselElement.vue?vue&type=script&lang=js"
export * from "./CarouselElement.vue?vue&type=script&lang=js"
import style0 from "./CarouselElement.vue?vue&type=style&index=0&id=ee7e3dd8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports